import MenuIcon from '../../assets/menu-Icon.png';
import logoMobile from '../../assets/sensforge-logo-mobile.svg';
import logoDesktop from '../../assets/sensforge-logo.png';
import ShoppingCart from '../../assets/ShoppingCart.png';
import { Link, useHistory } from 'react-router-dom';
import { type FC, useState, useRef } from 'react';
import styled from 'styled-components';
import { jwtDecode } from 'jwt-decode';
import { FaShoppingCart } from 'react-icons/fa';
import { useCartContext } from '../../context/cart_context';
import { useProductsContext } from '../../context/products_context';

const HeaderContainer = styled.header``;
const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.25rem;
  padding-right: 1rem;
  padding-top: 1rem;
  background: #faf5f3;
`;
const LogoRow = styled.div`
  display: flex;
  height: 70px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;
const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
`;
const LogoMobile = styled.img`
  height: 2rem;
  width: auto;
  display: block;
  @media (min-width: 880px) {
    display: none;
  }
`;
const LogoDesktop = styled.img`
  display: none;
  @media (min-width: 880px) {
    display: block;
    height: 2rem;
    width: auto;
  }
`;
const Nav = styled.nav`
  display: none;
  @media (min-width: 880px) {
    display: flex;
    gap: 2rem;
    margin-left: 3rem;
    color: #000;
    align-items: center;
    flex: 1;
  }
`;
const NavLink = styled(Link)`
  color: #000;
  text-decoration: none;
`;
const RightRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
const MobileNav = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  @media (min-width: 769px) {
    display: none;
  }
`;
const MenuButton = styled.a`
  cursor: pointer;
`;
const MenuImg = styled.img`
  display: flex;
`;
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
`;
const Drawer = styled.div`
  background: #faf5f3;
  box-shadow: 0 4px 24px rgba(0,0,0,0.1);
  width: 90%;
  max-width: 400px;
  padding: 1rem;
  height: 100vh;
`;
const DrawerNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const DrawerLink = styled(Link)`
  display: block;
  text-align: center;
  padding: 0.5rem 0.5rem;
  font-size: 18px;
  color: #000;
  text-decoration: none;
`;
const DrawerButton = styled.button`
  display: block;
  text-align: center;
  padding: 0.5rem 0.5rem;
  font-size: 18px;
  color: #000;
  text-decoration: none;
  background: none;
  border: none;
  width: 100%;
  cursor: pointer;
  font-family: inherit;
`;
const RightAligned = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  white-space: nowrap;
`;
const CreateAccountLink = styled(Link)`
  color: #222;
  text-decoration: none;
  font-weight: 400;
  font-size: 1rem;
  margin-right: 0;
  display: inline;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
const SignInButton = styled(Link)`
  background: #F87B15;
  color: #fff;
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 1.5rem;
  margin-right: 0;
  text-decoration: none;
  font-weight: 700;
  font-size: 1rem;
  box-shadow: none;
  transition: background 0.2s, color 0.2s;
  display: inline;
  &:hover {
    background: #d96a10;
    color: #fff;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
const UserDropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  right: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  min-width: 120px;
  z-index: 100;
  margin-top: 0.5rem;
  padding: 0.5rem 0;
  text-align: left;
  flex-direction: column;
  gap: 0;

  ${UserDropdown}:hover & {
    display: block;
  }
`;

const DropdownItem = styled.button`
  background: none;
  border: none;
  color: #5B2A13;
  width: 100%;
  text-align: left;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  cursor: pointer;
  display: block;
  &:hover {
    background: #f7f7f7;
  }
  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;

const CartButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }

  .cart-btn {
    color: #5B2A13;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    position: relative;
    text-decoration: none;
    font-weight: 600;
    margin-left: 0.5rem;
  }
  .cart-container {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 0.5rem;
  }
  .cart-value {
    position: absolute;
    top: -10px;
    right: -16px;
    background: #F87B15;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 0.75rem;
    color: #fff;
    padding: 12px;
  }
`;

const UserCartGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  white-space: nowrap;
`;

const RightSideContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const NavDropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const NavDropdownButton = styled.button`
  background: none;
  border: none;
  color: #000;
  font-size: 1rem;
  font-family: 'Nunito', sans-serif;
  cursor: pointer;
  padding: 0;
  font-weight: 400;
  &:hover {
    text-decoration: underline;
  }
`;

const NavDropdownMenu = styled.div`
  display: none;
  position: absolute;
  left: 0;
  top: 100%;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  min-width: 260px;
  z-index: 100;
  margin-top: 0.5rem;
  padding: 0.5rem 0;
  text-align: left;
  flex-direction: column;
  gap: 0;
  @media (max-width: 879px) {
    position: static;
    box-shadow: none;
    border: none;
    margin-top: 0;
    min-width: unset;
  }
  ${NavDropdown}:hover & {
    display: block;
  }
`;

const NavDropdownItem = styled(Link)`
  display: block;
  padding: 0.75rem 1.25rem;
  color: #5B2A13;
  font-size: 1rem;
  text-decoration: none;
  background: none;
  border: none;
  text-align: left;
  width: 100%;
  cursor: pointer;
  &:hover {
    background: #f7f7f7;
    text-decoration: underline;
  }
`;

interface JwtPayload {
  userId: number;
  email: string;
}

function getUserFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return null;
  }
}

export const CommonHeader: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const user = getUserFromToken();
  const { totalItems } = useCartContext();
  const { closeSidebar } = useProductsContext();
  const history = useHistory();
  const handleSignOut = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };

  const handleSignInClick = () => {
    localStorage.setItem('postLoginRedirect', window.location.pathname + window.location.search);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleDropdownEnter = () => {
    if (dropdownTimeout.current) clearTimeout(dropdownTimeout.current);
    setDropdownOpen(true);
  };

  const handleDropdownLeave = () => {
    dropdownTimeout.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 400); // 400ms delay before closing
  };

  // Product dropdown state and handlers
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);
  const productDropdownTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleProductDropdownEnter = () => {
    if (productDropdownTimeout.current) clearTimeout(productDropdownTimeout.current);
    setProductDropdownOpen(true);
  };

  const handleProductDropdownLeave = () => {
    productDropdownTimeout.current = setTimeout(() => {
      setProductDropdownOpen(false);
    }, 300); // 400ms delay before closing
  };

  return (
    <HeaderContainer>
      <TopBar>
        <LogoRow>
          <div style={{ flexShrink: 0 }}>
            <LogoLink to="/">
              <LogoMobile src={logoMobile} alt="Sensforge" />
              <LogoDesktop src={logoDesktop} alt="Sensforge" />
            </LogoLink>
          </div>
          <Nav>
            <NavLink to="/index">Home</NavLink>
            <NavDropdown
              onMouseEnter={handleProductDropdownEnter}
              onMouseLeave={handleProductDropdownLeave}
            >
              <NavDropdownButton type="button">Products ▾</NavDropdownButton>
              <NavDropdownMenu style={{ display: productDropdownOpen ? 'block' : 'none' }}>
                <NavDropdownItem to="/indoor-pan-tilt-camera">Indoor Pan-Tilt Camera</NavDropdownItem>
                <NavDropdownItem to="/smart-bird-feeder">Smart Bird Feeder</NavDropdownItem>
              </NavDropdownMenu>
            </NavDropdown>
            <NavLink to="/support">Support</NavLink>
          </Nav>
        </LogoRow>
        <RightSideContainer>
          <RightAligned>
            {!user ? (
              <>
              </>
            ) : (
              <UserDropdown
                onMouseEnter={handleDropdownEnter}
                onMouseLeave={handleDropdownLeave}
              >
                <span style={{ fontWeight: 600, cursor: 'pointer' }}>Hello! {user.email}</span>
                <DropdownMenu style={{ display: dropdownOpen ? 'block' : 'none' }}>
                  <DropdownItem onClick={() => history.push('/orders')}>My Orders</DropdownItem>
                  <DropdownItem onClick={handleSignOut}>Sign Out</DropdownItem>
                </DropdownMenu>
              </UserDropdown>
            )}
          </RightAligned>
        <RightRow>
          <MobileNav>
            <MenuButton href="javascript:;" onClick={toggleMenu}>
              <MenuImg src={MenuIcon} />
            </MenuButton>
          </MobileNav>
        </RightRow>
        </RightSideContainer>
      </TopBar>
      {isMenuOpen && (
        <Overlay>
          <Drawer>
            <DrawerNav>
              <DrawerLink to="/index" onClick={toggleMenu}>Home</DrawerLink>
              <DrawerLink to="/indoor-pan-tilt-camera" onClick={toggleMenu}>Indoor Pan Tilt</DrawerLink>
              <DrawerLink to="/smart-bird-feeder" onClick={toggleMenu}>Smart Bird Feeder</DrawerLink>
              <DrawerLink to="/plan" onClick={toggleMenu}>Plans</DrawerLink>
              <DrawerLink to="/support" onClick={toggleMenu}>Support</DrawerLink>
              <DrawerLink to="/community" onClick={toggleMenu}>Community</DrawerLink>
              {!user ? (
                <>
                </>
              ) : (
                <>
                  <DrawerLink to="/orders" onClick={toggleMenu}>My Orders</DrawerLink>
                  <DrawerButton onClick={handleSignOut}>Sign Out</DrawerButton>
                </>
              )}
            </DrawerNav>
          </Drawer>
        </Overlay>
      )}
    </HeaderContainer>
  );
};
